import React from 'react';
import { LeaderboardType } from '../types';
import { CalendarDays, CalendarRange, Trophy } from 'lucide-react';

interface NavigationProps {
  activeTab: LeaderboardType;
  onTabChange: (tab: LeaderboardType) => void;
}

const NavigationRanking: React.FC<NavigationProps> = ({ activeTab, onTabChange }) => {
  const tabs: { id: LeaderboardType; label: string; icon: React.ReactNode }[] = [
    { 
      id: 'weekly', 
      label: 'This Week', 
      icon: <CalendarRange className="w-5 h-5 mr-2" /> 
    },
    { 
      id: 'monthly', 
      label: 'This Month', 
      icon: <CalendarDays className="w-5 h-5 mr-2" /> 
    },
    { 
      id: 'allTime', 
      label: 'All Time', 
      icon: <Trophy className="w-5 h-5 mr-2" /> 
    },
  ];

  return (
    <div className="flex justify-center mb-8">
      <div className="inline-flex rounded-md shadow-sm bg-slate-800 p-1" role="group">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-md flex items-center transition-all duration-300 ${
              activeTab === tab.id
                ? 'bg-slate-700 text-white'
                : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
            }`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationRanking;